import { AuthProviderType } from '../api/v3/AuthProvider';
import * as common from '../Common';
function userPassProvider(auth) {
    var providerRoute = 'providers/local-userpass';
    var loginRoute = providerRoute + "/login";
    return {
        authenticate: function (_a) {
            var username = _a.username, password = _a.password;
            var fetchArgs = common.makeFetchArgs('POST', {
                body: JSON.stringify({ username: username, password: password }),
            });
            return fetch(auth.rootUrl + "/" + loginRoute, fetchArgs)
                .then(common.checkStatus)
                .then(function (response) { return response.json(); })
                .then(function (json) { return auth.set(json); });
        },
    };
}
function apiKeyProvider(auth) {
    var loginRoute = 'providers/api-key/login';
    return {
        authenticate: function (key) {
            var fetchArgs = common.makeFetchArgs('POST', {
                body: JSON.stringify({ key: key }),
            });
            return fetch(auth.rootUrl + "/" + loginRoute, fetchArgs)
                .then(common.checkStatus)
                .then(function (response) { return response.json(); })
                .then(function (json) { return auth.set(json); });
        },
    };
}
function mongodbCloudProvider(auth) {
    var loginRoute = 'providers/mongodb-cloud/login';
    return {
        authenticate: function (data) {
            var username = data.username, apiKey = data.apiKey, cors = data.cors, cookie = data.cookie;
            var options = {
                cookie: cookie || false,
                cors: cors || true,
            };
            var fetchArgs = common.makeFetchArgs('POST', {
                body: JSON.stringify({ username: username, apiKey: apiKey }),
            });
            fetchArgs.credentials = 'include';
            var url = auth.rootUrl + "/" + loginRoute;
            if (options.cookie) {
                return fetch(url + "?cookie=true", fetchArgs).then(common.checkStatus);
            }
            return fetch(url, fetchArgs)
                .then(common.checkStatus)
                .then(function (response) { return response.json(); })
                .then(function (json) { return auth.set(json); });
        },
    };
}
function createProviders(auth) {
    var _a;
    return _a = {},
        _a[AuthProviderType.MongoDBCloud] = mongodbCloudProvider(auth),
        _a[AuthProviderType.APIKey] = apiKeyProvider(auth),
        _a[AuthProviderType.Userpass] = userPassProvider(auth),
        _a;
}
export default createProviders;
//# sourceMappingURL=Providers.js.map